"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.regexp.search");
var _gift_card = require("@/api/community/gift_card.js");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'GiftCardTablePane',
  components: {},
  props: {
    imgAccessDomain: {
      type: String,
      required: true
    }
  },
  data: function data() {
    return {
      loading: false,
      tableKey: 0,
      total: 0,
      tableData: [],
      listQuery: {
        keywords: '',
        page: 1,
        limit: 20
      }
    };
  },
  created: function created() {
    this.search();
  },
  methods: {
    giftCardSend: function giftCardSend(row) {
      this.$emit('toGiftCardAssignTask', row.fnId);
    },
    viewCardList: function viewCardList(row) {
      this.$emit('toCardList', row.fnId);
    },
    search: function search() {
      this.listQuery.page = 1;
      this.handleFilter();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.listQuery.page = val;
      this.handleFilter();
    },
    handleSizeChange: function handleSizeChange(val) {
      this.listQuery.limit = val;
      this.search();
    },
    handleFilter: function handleFilter() {
      var _this = this;
      this.loading = true;
      (0, _gift_card.getGiftCardPage)(this.listQuery).then(function (response) {
        _this.tableData = response.records;
        _this.total = response.total;
        _this.loading = false;
      }).catch(function (error) {
        console.log(error);
        _this.loading = false;
      });
    },
    addGiftCard: function addGiftCard() {
      this.$emit('toGiftCardConfig', null);
    },
    editGiftCard: function editGiftCard(row) {
      console.log('editGiftCard', row);
      this.$emit('toGiftCardConfig', row.fnId);
    },
    delGiftCard: function delGiftCard(row) {
      var _this2 = this;
      console.log('delGiftCard', row);
      this.$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        _this2.$message.success('删除成功');
      }).catch(function () {
        _this2.$message.info('已取消删除');
      });
    }
  }
};